<vshc-dialog
  [backdropClass]="'c-login-backdrop'"
  [options]="{ panelClass: 'c-login-pane' }"
  [open]="state.isOpen && !state.isCheckingAuth">
  <div class="__wrap">
    <div class="__content">
      <h2
        class="__heading"
        [innerHTML]="state.translations?.title">
      </h2>

      <a
        [href]="authWebsiteUrl"
        mat-flat-button
        class="__button  c-button--larger"
        color="accent">
        <mat-icon class="__icon">login</mat-icon>
        &nbsp;
        <span>{{ state.translations?.authWebsiteButton }}</span>
      </a>
    </div>
  </div>

  <!-- Disabled until direct login to CDN is enabled -->
  <!--
  <div class="__form-wrap">
    <vshcdn-login-form [state]="state.loginFormState">
      <zef-progress-error [key]="loginKey">
        <button
          mat-flat-button
          color="primary"
          (click)="onSubmit$.next()"
          type="button">
          Login
        </button>
      </zef-progress-error>
    </vshcdn-login-form>
  </div>
  -->

</vshc-dialog>
